import { render } from "./FileViewer.vue?vue&type=template&id=1dbef804&ts=true"
import script from "./FileViewer.vue?vue&type=script&lang=ts"
export * from "./FileViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__